
export const getHost = ()=>{
    const { protocol, host } = window.location;
    const url=`${protocol}//${host}`
    if(url==="http://localhost:3000"){
        return "http://localhost:5001";
    }
    return url;
}